import { useContext } from 'react';
import { MessagingStore } from '../store/messaging-store';
import { createContext } from 'react';

export const MessagingStoreContext = createContext<MessagingStore | undefined>(undefined);

export const useMessagingStore = () => {
    const messagingStore = useContext(MessagingStoreContext);
    if (!messagingStore) throw new Error("Couldn't find MessagingContext");

    return messagingStore;
};
